<template>
  <textarea
      class="text-area"
      :disabled="disabled"
      :placeholder="placeholder"
      @change="(e) => handleTextArea(e.target.value)"
      :value="value"
      :required="required"
  />
</template>
<script>
export default {
  name: "TextArea",
  props: {
    handleTextArea: Function,
    placeholder: String,
    value: String,
    disabled: Boolean,
    required: {
      type: Boolean,
      default: true,
    }
  },
};
</script>
<style lang="scss" scoped>
.text-area {
  margin-bottom: 20px;
  width: 100%;
  border: 0.5px solid rgba(97, 110, 124, 0.25);
  box-sizing: border-box;
  border-radius: 4px;
  outline: none;
  padding: 16px;
  height: 80px;
}

textarea:disabled {
  background: rgba(13, 72, 64, 0.05) !important;
  color: #000;
}
</style>
